import React, { useMemo } from 'react';
import { Grid } from '@material-ui/core';

import { FilterViewTypes, IFilter, IFilterSettings, IFilterValue } from 'common/interfaces/filter';

import Filter from '../Filter/Filter';
import { makeFilterChangeHandler } from 'common/utils/filter';

interface FilterListProps {
  filters: string[];
  settings: IFilterSettings[];
  values: IFilter[];
  onFiltersChange: (values: IFilter[], changedFilterName?: string) => void;
  filterView?: FilterViewTypes;
}

const FilterList = ({
  filters,
  settings,
  values,
  filterView = FilterViewTypes.DROPDOWN,
  onFiltersChange,
}: FilterListProps): JSX.Element => {
  const getFilterValue = (filterName: string): IFilterValue => {
    const filterValue = values.find(value => value.name === filterName);
    return filterValue ? filterValue.value : null;
  };

  const handleFilterChange = useMemo(() => makeFilterChangeHandler(values, onFiltersChange), [
    values,
    onFiltersChange,
  ]);

  const shownSettings = settings.filter(setting => filters.includes(setting.name));

  return (
    <>
      {shownSettings.map(filterSettings => {
        if (filterSettings.hidden) {
          return null;
        }

        return (
          <Grid item key={filterSettings.name}>
            <Filter
              settings={filterSettings}
              value={getFilterValue(filterSettings.name)}
              viewType={filterView}
              handleFilterChange={handleFilterChange}
            />
          </Grid>
        );
      })}
    </>
  );
};

export default React.memo(FilterList);
